import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class ListSelectionRecord
 * @augments BaseMessageRecord
 */
class ListSelectionRecord extends BaseMessageRecord({
  type: "list_selection_template",

  /**
   * @memberof ListSelectionRecord#
   */
  prompt: "",
  errorResponseId: "",
  selectables: Immutable.List(),
  multiple: false,
  variableId: "",
  hasValidVariable: true
}) {}

/**
 * Creates a new empty row for the UI from a given string value.
 *
 * @param {String} value
 * @returns {Immutable.Map}
 */
ListSelectionRecord.createRow = (value = "") => Immutable.Map({
  configuredFieldType: "string", // either "string" or "variable"
  value
});

/**
 * Validation
 */


/**
 * @param {ListSelectionRecord} message
 * @returns {Immutable.List.<String>}
 */
ListSelectionRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (message.prompt.trim() === "") {
    invalidFields.add("prompt");
  }

  if (message.errorResponseId === "") {
    invalidFields.add("errorResponseId");
  }

  if (message.hasValidVariable === false) {
    invalidFields.add("variableId");
  }

  const hasEmptyOption = message.selectables.some(s => s.get("value") === "");

  if (hasEmptyOption) {
    invalidFields.add("selectables");
  }

  return Immutable.List(invalidFields);
};

export default ListSelectionRecord;
